import { z } from "zod";

export enum RoomTypeEnum {
  DocumentationPageOld = "documentation-page",
  DocumentationPage = "doc-page",
  DesignSystemVersion = "design-system-version",
  Workspace = "workspace",
  ForgeProject = "forge-project",
}

export const RoomTypeSchema = z.nativeEnum(RoomTypeEnum);

export type RoomType = z.infer<typeof RoomTypeSchema>;
export const RoomType = RoomTypeSchema.enum;

//
// Room owners
//

export type WorkspaceRoomOwner = {
  type: "Workspace";
  workspaceId: string;
};

export type VersionRoomOwner = {
  type: "DesignSystemVersion";
  workspaceId: string;
  designSystemId: string;
  designSystemVersionId: string;
};

export type ForgeProjectRoomOwner = {
  type: "ForgeProject";
  projectId: string;
  // We do not store `workspaceId` neither in DB nor in Liveblocks.
  // Used for ACLs now, could be removed once we move to project ACLs in `checkSessionAccess`.
  workspaceId: string;
};

export type RoomOwner = WorkspaceRoomOwner | VersionRoomOwner | ForgeProjectRoomOwner;

//
// Room ids
//

export type WorkspaceParsedRoomId = {
  type: RoomTypeEnum.Workspace;
  raw: string;
};

export type DesignSystemVersionParsedRoomId = {
  type: RoomTypeEnum.DesignSystemVersion;
  raw: string;
};

export type DocumentationPageOldParsedRoomId = {
  type: RoomTypeEnum.DocumentationPageOld;
  raw: string;
};

export type DocumentationPageParsedRoomId = {
  type: RoomTypeEnum.DocumentationPage;
  raw: string;

  /**
   * Id of DS version, cannot be a wildcard (always a specific ID)
   */
  designSystemVersionId: string;

  /**
   * Documentation page persistent ID or wildcard `*`
   */
  pagePersistentId: string;
};

export type ForgeProjectParsedRoomId = {
  type: RoomTypeEnum.ForgeProject;
  raw: string;
};

export type ParsedRoomId =
  | WorkspaceParsedRoomId
  | DesignSystemVersionParsedRoomId
  | DocumentationPageOldParsedRoomId
  | DocumentationPageParsedRoomId
  | ForgeProjectParsedRoomId;
